import { render, staticRenderFns } from "./tabs-base.vue?vue&type=template&id=0f60f225&scoped=true&"
import script from "./tabs-base.vue?vue&type=script&lang=js&"
export * from "./tabs-base.vue?vue&type=script&lang=js&"
import style0 from "./tabs-base.vue?vue&type=style&index=0&id=0f60f225&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f60f225",
  null
  
)

export default component.exports